import { VStack, Box, Col, Row } from "@reverb-ui/react";
import { SortedTable } from "presentation/components/SortedTable";
import { useContext } from "react";
import { MetricCard } from "../../components/MetricCard";
import { PageSummaryContext } from "../context-api/PageSummaryProvider";
import { IconVariationEnum } from "data/constants/constants";
import { ListCardSkeleton } from "presentation/components/Skeleton/CardSkeleton";
import { SortedTableSkeleton } from "presentation/components/Skeleton/SortedTableSkeleton";
import { panelsInfo } from "helper/panelsHelper";
import PanelContainer from "presentation/components/PanelContainer";

const pageSummaryInfo = panelsInfo.pageSummary;

export const PageSummaryReports = () => {
  const {
    requestParamsIndex,
    pageSummaryData,
    downloadPageSummaryReport,
    downloadingReports,
    isLoading,
  } = useContext(PageSummaryContext);

  return (
    <PanelContainer
      panelId={pageSummaryInfo.htmlId}
      panelName={pageSummaryInfo.description}
      rangeName={pageSummaryData?.range}
      isLoading={isLoading}
      downloadOptions={{
        onClickGenerateCSV: downloadPageSummaryReport,
        downloadingReports: downloadingReports,
        panelInfo: pageSummaryInfo,
        filterStateIndex: requestParamsIndex,
      }}
    >
      <Row>
        <Col col={!isLoading && pageSummaryData?.cards.length === 0 ? 0 : 3}>
          {isLoading ? (
            <ListCardSkeleton
              numberOfCards={2}
              spacingBetween={5}
              hasSubText={true}
              hasVariationPeriod={true}
            />
          ) : (
            <VStack w="full" spacing={5}>
              {pageSummaryData?.cards.map((item, index) => (
                <MetricCard
                  key={index}
                  order={item.order}
                  iconName={item.iconTitle}
                  title={item.title}
                  description={item.text}
                  variation={item.percentageVariation}
                  variationPeriod={item.previousRange}
                  variationType={item.iconVariation as IconVariationEnum}
                  subDescription={item.subText}
                />
              ))}
            </VStack>
          )}
        </Col>
        <Col
          col={!isLoading && pageSummaryData?.cards.length === 0 ? 12 : 9}
          className="col-sorted-table"
        >
          <Box
            bg="white"
            w="full"
            p={6}
            height={400}
            overflow="auto"
            className="sortedTable"
          >
            {isLoading ? (
              <SortedTableSkeleton numberOfColumns={6} />
            ) : (
              <SortedTable
                dataColumns={pageSummaryData?.summary.dataColumns || []}
                dataRows={pageSummaryData?.summary.dataRows || []}
              />
            )}
          </Box>
        </Col>
      </Row>
    </PanelContainer>
  );
};
